module.exports = __webpack_public_path__ + "img/20190727141345743.a74fb57e.png";